import './Text.css';
import ShapeOfYou from './ShapeOfYou.gif'

export function About() {
  return (
<div class="body">
<div class="row" id="GalleryThree">
   <div class="column" id="centered">
<img class="aboutLogoType" src="AmarAgba-White.png"/>
  

                 <h2>
Editorial Designer & Community Engagement Specialist <br/>
<h4>With a BFA in graphic design from the Minneapolis College of Art and Design and over 8 years of creative freelancing, Amar is a highly trained creative project manager for print, digital, and social productions.</h4>

</h2>
     <h6>
                <a href="mailto:wet.cloud@proton.me">Email</a>
&emsp;
          <a href="https://www.instagram.com/caagbaart/" target="0">&emsp;Instagram</a>
          &emsp;&emsp;<a href="https://www.instagram.com/caagbaart/" target="0">LinkedIn</a>
          &emsp;&emsp;<a href="https://www.instagram.com/caagbaart/" target="0">Youtube</a>
         
          </h6>

<br/><br/>
<img src="BallroomBookmarks01.png"></img>
            <h6><a href="/ ">Ballroom Bookmarks</a>
                , 2026
                <br/>Pride Month Programming at the Minneapolis Institute of Art</h6>
<br/><br/>




  </div>

    <div class="column" id="centered">
<br/>
                <a href="/MajorMinorFair">
              <img alt="Major Minor Fair 2024" src="2024_MajorMinorFairIntranetGraphic_Optimized-PC.gif" href="/ASD.js"/>
          </a>
          <h6>
          <a href="/MajorMinorFair">
              Major Minor Fair
          </a>, 2024
    <br/>
              <b>Client</b>: Minneapolis College of Art and Design.

          </h6>

<br/>  <br/>
                  <a href="/FreedomSchool">
               <img alt="Freedom School" src="FreedomSchool03.jpg"></img>
            </a>

            <h6><a href="/FreedomSchool">Freedom School</a>
                , 2025
                <br/>James and Grace Lee Boggs Foundation, Detroit, MI</h6>

                 <br/>  
    </div>

   <br/>

  <div class="column" id="centered">
    <br/>  

            <div >
               <a href="/WeatherBody"> <img alt="Weather Body" src="WeatherBody15_1.jpg"/></a>
            </div>
            <h6>
                <a href="/WeatherBody">
   Weather Body
                </a>, 2025
               <br/>
               Poetry Anthology
                </h6>

<br/>
                  <a href="/Preach">
               <img alt="How Can You Love Someone Who Wants You Dead?" src="Preach.gif"></img>
            </a>


            <h4><a href="/Preach">How Can You Love Someone Who Wants You Dead?</a>
                , 2025
                <br/> Open mic with worksheets </h4>


       {/* 
<h4>   

<h2>Digital Production:</h2> 
Documentary &#9733; Data Visualization &#9733; Video and Sound editing &#9733; Brand Identity Development &#9733; Motion Graphics &#9733; Captioning &#9733; Journalism.
<br/><h2>Pre-press Print Production:</h2> 
Intructional Documents &#9733; Leaflets &#9733; Booklets and Zines &#9733; Posters &#9733; Screen Printing &#9733; Wheat Pasting.
<br/><h2>Programming:</h2>
Age-Specific Art Curriculum &#9733; Tutorials &#9733; Poetry Open-Mic Emceeing.
<br/><br/>
 Click <a href="/ShopDonate">Shop</a> to understand how I price my work!
<br/>*Amar does not condone the use of AI
<br/><br/>
<hr/>

</h4>
 */}

  </div>
    </div>

<div class="row" id="GalleryThree">
   <div class="column">
  <h2>

  Group Exhibitions
  <hr/>
          <br/>
        Teen Perspectives: Today and Tomorrow
        <br/><h4><em>Minneapolis Institute of Art, 2026.</em></h4>
        <br/>
        Fondly Thinking
        <br/><h4><em>Hennepin County Library Group Exhibit,<br/> Minneapolis 2026.</em></h4>
        <br/>
        Future of Design
        <br/><h4><em>Minneapolis College of Art And Design, 2025.</em></h4>
        <br/>
        MCAD Foundations Exhibit
        <br/><h4><em>Homewood Studios 2022.</em></h4>
        <br/>
        Black Arts and Music Festival 
       <br/><h4><em> Ames Public Library, Ames, IA, 2021.</em></h4>
        <br/>
             Art Walk
        <br/><h4><em>Ames Public Library, Ames, IA 2021.</em></h4>
        <br/>
        Black Arts and Music Festival
        <br/><h4><em>Ames Public Library 2021, Ames, IA, 2021.</em></h4>
        <br/>
        Outrage to Change Project
        <br/><h4><em>Octagon Art Center, Ames, IA ,2020.</em></h4>  

     </h2>

</div>

  <div class="column">
  <h2>
Programs<br/>  <hr/><br/>
        Ballroom Bookmarks <br/>
             <h4><em> Pride Meet at Mia,<br/>
  Minneapolis Institute of Art, 2026.</em></h4>
        <br/>
        Wet Cloud<br/>
           <h4><em> Poetry Open Mic, <br/>
    Hennepin County Library, 2026.</em></h4>
        <br/>
        PREACH<br/>
                <h4><em>   Poetry Open Mic, <br/>
        Minneapolis College of Art and Design, 2025.</em></h4>
        <br/>
        Kehinde Wiley-inspired Street Art Stencils<br/>
            <h4><em>Black History Month Family Day,<br/>
        Minneapolis Institute of Art, 2026.</em></h4>
        <br/>
        Bob Thompson-inspired Community Collage<br/>
<h4><em>Black History Month Family Day,<br/>
Minneapolis Institute of Art, 2025.</em></h4>
        </h2>

</div>
  <div class="column">
  <h2>
Performances  <hr/> <br/>
        People's Pride<br/>
        <h4><em>Minneapolis, MN 2026.</em></h4>
        <br/>
        Rough Draft<br/>
        <h4><em>Minneapolis, MN 2026.</em></h4>
        <br/>
        </h2>

</div>
</div>

</div>

  );
}
